var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCross = function SvgIconCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 13.05 6.75 18.3a.72.72 0 0 1-.525.225.72.72 0 0 1-.525-.225.72.72 0 0 1-.225-.525q0-.3.225-.525L10.95 12 5.7 6.75a.72.72 0 0 1-.225-.525q0-.3.225-.525a.72.72 0 0 1 .525-.225q.3 0 .525.225L12 10.95l5.25-5.25a.72.72 0 0 1 .525-.225q.3 0 .525.225a.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525L13.05 12l5.25 5.25a.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525.72.72 0 0 1-.525.225.72.72 0 0 1-.525-.225z"
  })));
};
export default SvgIconCross;